import { Divider, Stack, Typography } from '@mui/material'
import { Fragment } from 'react'

import {
  PreSale,
  PreSaleLotteryConfirmationFragment,
} from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type FirstComeFirstServedSubTitleCellProps = {
  preSale:
    | (PreSaleLotteryConfirmationFragment &
        Pick<PreSale, 'firstComeFirstServed'>)
    | undefined
}
export const FirstComeFirstServedSubTitleCell: Cell<FirstComeFirstServedSubTitleCellProps> =
  ({ preSale }) => {
    const { t } = useTranslation('firstComeFirstServedConfirmation')
    const contents = [
      {
        title: t('preSale', '先行販売'),
        content: preSale?.title,
      },
      {
        title: t('purchasableDate', '購入期間'),
        content: `${preSale?.firstComeFirstServed?.formattedPurchasableStartedAt} 〜 ${preSale?.firstComeFirstServed?.formattedPurchasableEndedAt}`,
      },
    ]

    return (
      <CellFrame sx={{ pb: 5 }}>
        <Stack sx={{ px: 2, py: 1, bgcolor: 'grey.50' }}>
          <Typography variant="h5" color="text.secondary">
            {t('information', '公演情報')}
          </Typography>
        </Stack>
        <Stack sx={{ pt: 3 }}>
          {contents.map((content, index) => (
            <Fragment key={index}>
              <Stack spacing={1} sx={{ py: 2 }}>
                <Typography variant="subtitle1" color="text.secondary">
                  {content.title}
                </Typography>
                <Typography variant="body2">{content.content}</Typography>
              </Stack>
              {index < contents.length - 1 && <Divider />}
            </Fragment>
          ))}
        </Stack>
      </CellFrame>
    )
  }
